import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import { ServiceLandingPage } from "./components/service-page/ServiceLandingPage";
import { SERVICE_PAGES } from "./data/servicePages";
import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import SeoPreviewFrame from "./pages/SeoPreviewFrame";

if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-black" />;
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
};

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const timer = setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
      return () => clearTimeout(timer);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster theme="dark" position="top-right" />
        <Routes>
          <Route path="/" element={<Home />} />
          {SERVICE_PAGES.map((page) => (
            <Route key={page.slug} path={page.slug} element={<ServiceLandingPage page={page} />} />
          ))}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/preview/seo-page" element={<SeoPreviewFrame />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
